'use client';

import { useTranslation } from '@/lib/i18n/LanguageContext';

const QUICK_ADD = [10, 50, 100, 250];

interface PriceInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export function PriceInput({ value, onChange, onSubmit }: PriceInputProps) {
  const { t } = useTranslation();
  const canSubmit = Number(value) > 0;

  const add = (n: number) => onChange(String((Number(value) || 0) + n));

  return (
    <section className="card anim-rise p-4" style={{ animationDelay: '80ms' }}>
      <label
        htmlFor="price-guess"
        className="block text-center text-xs font-semibold uppercase tracking-widest text-muted"
      >
        {t('guessPrice')}
      </label>

      <div className="mx-auto mt-3 flex max-w-xs items-center justify-center gap-1 border-b-2 border-line pb-1 transition-colors focus-within:border-accent">
        <span className="font-display text-4xl font-extrabold text-muted">$</span>
        <input
          id="price-guess"
          type="number"
          inputMode="numeric"
          min={0}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && canSubmit && onSubmit()}
          placeholder="0"
          autoFocus
          className="input-price w-40 bg-transparent text-center font-display text-5xl font-extrabold outline-none placeholder:text-line"
        />
      </div>

      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        {QUICK_ADD.map((n) => (
          <button
            key={n}
            type="button"
            onClick={() => add(n)}
            className="btn-ghost px-3 py-1 font-mono text-sm"
          >
            +{n}
          </button>
        ))}
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            className="px-2 py-1 text-sm text-muted underline-offset-4 hover:text-fg hover:underline"
          >
            {t('clear')}
          </button>
        )}
      </div>

      <button onClick={onSubmit} disabled={!canSubmit} className="btn-primary mt-4 w-full py-3 text-base">
        {t('validate')}
      </button>
    </section>
  );
}
